import React, { useState } from "react";
import {
  StyledBlock,
  StyledCategoryFields,
  StyledTop,
  StyledTopImg,
  StyledTopText,
} from "pages/jetton/styled";
import LoadingImage from "components/LoadingImage";
import LoadingContainer from "components/LoadingContainer";
import { Box, Tooltip } from "@mui/material";
import Alert from "@mui/material/Alert";
import {
  adminActions,
  getAdminMessage,
  getFaultyMetadataWarning,
  getMetadataWarning,
  getTotalSupplyWarning,
  totalSupplyActions,
} from "pages/jetton/util";
import { DataRow } from "pages/jetton/dataRow/DataRow";
import BigNumberDisplay from "components/BigNumberDisplay";
import UpdateMetadata from "pages/jetton/actions/UpdateMetadata";
import useJettonStore from "store/jetton-store/useJettonStore";
import { AppHeading } from "components/appHeading";
import brokenImage from "assets/icons/question.png";
import { AppButton } from "components/appButton";
import pen from "assets/icons/pen.svg";
import { CenteringWrapper } from "components/footer/styled";

export const Token = () => {
  const {
    jettonImage,
    adminAddress,
    isAdmin,
    adminRevokedOwnership,
    symbol,
    name,
    description,
    jettonMaster,
    persistenceType,
    totalSupply,
    jettonWalletAddress,
    isJettonDeployerFaultyOnChainData,
    jettonLoading,
    decimals,
    isImageBroken,
  } = useJettonStore();
  const [openEdit, setOpenEdit] = useState(false);

  return (
    <StyledBlock sx={{ width: "calc(55% - 15px)" }}>
      {!openEdit ? (
        <>
          <StyledTop>
            <StyledTopImg>
              <LoadingImage
                src={!isImageBroken ? jettonImage : brokenImage}
                alt="jetton image"
                loading={jettonLoading}
              />
            </StyledTopImg>
            <StyledTopText marginLeft="4px" marginTop="3px">
              <LoadingContainer loading={jettonLoading} loaderWidth="80px">
                {name && (
                  <AppHeading
                    text={`${name} ${symbol && `(${symbol})`}`}
                    variant="h2"
                    fontWeight={800}
                    fontSize={20}
                    color="#161C28"
                  />
                )}
              </LoadingContainer>
              <LoadingContainer loading={jettonLoading} loaderWidth="150px">
                <Tooltip arrow title={description && description?.length > 80 ? description : ""}>
                  <Box marginTop=".5px" sx={{ maxWidth: 300, maxHeight: 60 }}>
                    <AppHeading
                      text={description || "Description"}
                      limitText={80}
                      variant="h4"
                      fontWeight={500}
                      fontSize={16}
                      color="#728A96"
                    />
                  </Box>
                </Tooltip>
              </LoadingContainer>
            </StyledTopText>
            {isAdmin && !adminRevokedOwnership && !jettonLoading && (
              <Box sx={{ alignSelf: "start" }}>
                <AppButton width={113} height={32} transparent onClick={() => setOpenEdit(true)}>
                  <CenteringWrapper>
                    <img
                      src={pen}
                      alt="Pen Icon"
                      width={15}
                      height={15}
                      style={{ marginRight: 4 }}
                    />
                    编辑代币
                  </CenteringWrapper>
                </AppButton>
              </Box>
            )}
          </StyledTop>
          {!isAdmin && isJettonDeployerFaultyOnChainData && (
            <Alert variant="filled" severity="error">
              {getFaultyMetadataWarning(adminRevokedOwnership)}
            </Alert>
          )}
          <StyledCategoryFields>
            <DataRow
              description="链上智能合约地址"
              title="代币合约地址"
              value={jettonMaster}
              dataLoading={jettonLoading}
              address={jettonMaster}
            />
            <DataRow
              title="权限地址"
              value={adminRevokedOwnership ? "Empty address" : adminAddress}
              address={adminAddress}
              description="权限地址可以自由铸造代币并更改元数据"
              message={getAdminMessage(
                jettonWalletAddress,
                symbol,
                adminRevokedOwnership,
                isAdmin,
                jettonMaster,
              )}
              dataLoading={jettonLoading}
              actions={adminActions}
              hasButton={isAdmin && !adminRevokedOwnership}
              showIcon={!isAdmin}
              regularAddress
            />
            <DataRow
              title="代币符号"
              value={symbol}
              dataLoading={jettonLoading}
              message={getMetadataWarning(persistenceType, adminRevokedOwnership)}
            />
            <DataRow
              title="精度"
              value={decimals}
              dataLoading={jettonLoading}
              message={getMetadataWarning(persistenceType, adminRevokedOwnership)}
            />
            <DataRow
              title="代币总量"
              value={
                totalSupply && (
                  <>
                    <BigNumberDisplay
                      value={totalSupply.toString()}
                      decimals={parseInt(decimals!)}
                    />{" "}
                    {symbol}
                  </>
                )
              }
              dataLoading={jettonLoading}
              message={getTotalSupplyWarning(persistenceType, adminRevokedOwnership)}
              actions={totalSupplyActions}
            />
          </StyledCategoryFields>
        </>
      ) : (
        <UpdateMetadata setOpen={setOpenEdit} />
      )}
    </StyledBlock>
  );
};
